import { SxProps, Theme } from '@mui/system';

const classes = {
  root: {
    width: '100%',
    marginTop: '8px',
  },

  header: {
    width: '100%',
    height: '40px',
    marginBottom: '12px',
    justifyContent: 'flex-start',
    font: 'inherit',
    textAlign: 'left',
  },

  titleLine: {
    flex: 1,
    height: '1px',
    marginX: '10px',
    backgroundColor: 'currentColor',
  },

  icon: {
    transition: 'transform 150ms',
  },

  iconExpanded: {
    transform: 'rotate(180deg)',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
